import { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardActionArea,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Icon,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Zoom,
} from "@mui/material";
import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";
import { ReactComponent as AttachmentAvatar } from "../assets/attacchment.svg";
import { ReactComponent as DeleteSVG } from "../assets/delete.svg";
import { categoryItems, docs_enum } from "../utils/helpers";
import store from "../store";
import { Tooltip } from "antd";

function UploadAttachmentModal(props) {
  const i18n = store.getState().i18n;

  const [alertText, setAlertText] = useState("");

  const handleFileChange = (e) => {
    let file = e.target.files[0];
    props?.setTarget(e);
    props?.setFile(file);
    if (props.customFileChange) {
      props.customFileChange(e);
    }

    if (!valedateDocument(file)) {
      setAlertText("Ungültige Dateierweiterung!");
    } else {
      setAlertText("");
    }
  };

  const deleteFile = () => {
    props?.setTarget();
    props?.setFile();
    setAlertText("");
  };

  const handleHideBtn = () => {
    props?.setShowButton(false);
  };

  const handleClose = () => {
    // setAlertText("");
    if (props.hasTitle) {
      props?.setTitle("");
    }

    if (props.hasDescription) {
      props?.setDescription();
    }
    if (props?.setAttachmentCategory) {
      props.setAttachmentCategory("");
    }
    deleteFile();
    props?.onClose();
  };

  const formatfileName = (str, limit) => {
    let name = str?.split(".");
    if (name?.length > 1) {
      if (name[0].length > limit) {
        return name[0]?.substr(0, limit) + "... ." + name[name.length - 1]; // name upto limit character + extention
      } else {
        return name[0]?.substr(0, limit) + "." + name[name.length - 1];
      }
    } else {
      return name;
    }
  };

  const renderFileDetails = () => {
    return (
      <div className="fileDetails">
        <div className="detail">
          <div className="name">
            {" "}
            {props?.file?.name
              ? formatfileName(props?.file?.name, 30)
              : props.title}
          </div>
          <div className="size">
            {" "}
            {props?.file.size ? props?.file.size / 1000 + "KB" : ""}
          </div>
        </div>
        <div className="icon">
          <DeleteSVG onClick={deleteFile} />
        </div>
      </div>
    );
  };

  const valedateDocument = (file) => {
    return file && file.type.length && docs_enum.includes(file.type);
  };

  let canChangeFile = props.file ? (props.file.size ? true : false) : true;

  return (
    <Dialog
      open={props?.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ backdropFilter: "blur(4px)" }}
      TransitionComponent={Zoom}
      className="uploadAttachmentModal"
      fullWidth={true}
      maxWidth="xs"
    >
      <DialogTitle id="alert-dialog-title">
        {"Datei "}
        {props.attachmentEditMode ? "bearbeiten" : "hochladen"}
      </DialogTitle>
      <DialogContent id="alert-dialog-description">
        <div
          style={{
            pointerEvents: canChangeFile ? "all" : "none",
            cursor: canChangeFile ? "pointre" : "not-allowed",
          }}
        >
          <input
            id="myInputDoc"
            style={{ display: "none" }}
            type={"file"}
            data-testid="upload_docs_file"
            accept={docs_enum}
            onChange={handleFileChange}
          />
          <Card
            sx={{
              height: 70,
              backgroundColor: canChangeFile ? "transparent" : "#d3d3d361",
            }}
            variant="outlined"
            style={{ marginBottom: 5 }}
          >
            {/* border: alertText?.length ? "1px solid red" : "1px solid rgba(0, 0, 0, 0.12)" */}
            <CardActionArea>
              {props?.file ? (
                renderFileDetails()
              ) : (
                <label htmlFor="myInputDoc">
                  <CardHeader
                    sx={{
                      height: 70,
                      cursor: "pointer",
                    }}
                    className="NT_cardHeader"
                    avatar={
                      <Icon color="primary" className={""}>
                        <AttachmentAvatar />
                      </Icon>
                    }
                    title={"Datei auswählen..."}
                  />
                </label>
              )}
            </CardActionArea>
          </Card>

          <Tooltip
          zIndex={11111}
            title={<div> Es sind nur (Text, PDF, Word, Excel) Dateien zulässig! </div>}
            placement="bottomLeft"
          >
            <div>
              {alertText.length > 0 && <div className="error">{alertText}</div>}
            </div>
          </Tooltip>
        </div>

        {props?.hasTitle ? (
          <TextField
            id="outlined-basic"
            label="Anzeigename"
            variant="outlined"
            value={props.title}
            onChange={(e) => {
              props?.setTitle(e.target.value);
            }}
            sx={{ marginTop: 3 }}
            fullWidth
          />
        ) : (
          ""
        )}
        {props?.hasDescription ? (
          <TextField
            id="outlined-basic"
            label="Kurzbeschreibung (optional)"
            variant="outlined"
            value={props.description}
            onChange={(e) => {
              props?.setDescription(e.target.value);
            }}
            sx={{ marginTop: 3, marginBottom: 3 }}
            fullWidth
          />
        ) : (
          ""
        )}

        {props.fromDragAndDrop ? (
          <FormControl fullWidth>
            <InputLabel id="kategorie-select-label">Kategorie</InputLabel>
            <Select
              labelId="kategorie-select-label"
              id="kategorie-select"
              value={props?.attachmentCategory ? props?.attachmentCategory : ""}
              onChange={(e) => {
                props?.setAttachmentCategory &&
                  props?.setAttachmentCategory(e.target.value.split("$")[0]);
              }}
              label="Kategorie"
            >
              {categoryItems.map((selectedCategory) => (
                <MenuItem value={selectedCategory.id} key={selectedCategory.id}>
                  {selectedCategory.category}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          ""
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "16px 26px" }}>
        <Button variant="text" onClick={handleClose}>
          ABBRECHEN
        </Button>
        {
          <Button
            variant="contained"
            onClick={() => {
              props?.handleSubmit(props.target);
            }}
            data-testid="btn_upload_attachment_model_save"
            disabled={
              props?.attachmentCategory === "" ||
              alertText.length ||
              props?.file === undefined
            }
          >
            <div>{props.editMode ? i18n.edit : i18n.save}</div>
          </Button>
        }
      </DialogActions>
    </Dialog>
  );
}

export default UploadAttachmentModal;
